import request from "@/utils/request";
import {
  fileService
} from "@/api/common/file-utils";
export default {
  getDataMdm: (data) => {
    return request({
      url: "/fpaPermanent/queryFpaForIssue",
      method: "post",
      data: data,
    });
  },
  resetMdm: (data) => {
    return request({
      url: "/fpaPermanent/backForIssueMDM",
      method: "post",
      data: data,
    });
  },
  confirmMdm: (data) => {
    return request({
      url: "/fpaPermanent/approveForIssueMDM",
      method: "post",
      data: data,
    });
  },
  getDCList: (data) => {
    return request({
      url: "/dc/dCMasterData",
      method: "post",
      data: data,
    });
  },
  getDetail: (id) => {
    return request({
      url: `dc/dCMasterDataSelect`,
      // url: `dc/dCMasterDataSelect/${id}`,
      method: "post",
      data: {
        tmSupplierId: id
      },
    });
  },
  getDCMumber: (DCMumber) => {
    return request({
      url: `dc/dCMasterDataSelect`,
      method: "post",
      data: {
        parentSupplierCode: DCMumber
      },
    });
  },
  save: (data) =>
    request({
      url: `dc/savedCMasterData`,
      method: "post",
      data: data,
    }),
  submit: (data) =>
    request({
      url: `dc/updateCMasterData`,
      method: "post",
      data: data,
    }),
  approval: (data) =>
    request({
      url: `dc/SubmitCMasterDataDCMasterData`,
      method: "post",
      data: data,
    }),
  listAllDc: (data) =>
    request({
      url: `dc/listAllDc`,
      method: "get",
    }),
  exportList: (param) =>
    request({
      url: "dc/dataListDownload",
      method: "post",
      fullResponse: true,
      responseType: "blob",
      data: param,
    }).then((resp) => {
      fileService.respToFile(resp, "DC.xls");
    }),
  editBelongsTo: (data) =>
    request({
      url: `dc/belongsTo`,
      method: "post",
      data: data,
    }),
};